<template>
	<button
		type="button"
		class="base-button"
		v-on="$listeners"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'BaseButton',
};
</script>

<style lang="stylus" scoped>
@require '../sizes'
@require '../colors'

.base-button
	background-color base-background-color
	color base-text-color
	border 0
	padding size-half size-single
	cursor pointer
	transition background-color .3s
	user-select none

	&:hover
		background-color #556
</style>



// WEBPACK FOOTER //
// src/components/BaseButton.vue